module.exports = __webpack_public_path__ + "assets/img/3-1.fcf94717.png";